import { setUserDataLocalStorage } from "../../../Scripts/getSetLocalStorage";
import { setAuthCookies } from "../../../Scripts/authCookies";
import { TransformAPIDataToUserData } from "../../../Services/UserDataService";

export const handleSuccessLogin = (json, context) => {
  setAuthCookies(json.data.user, json.data.token);

  const data = TransformAPIDataToUserData(json);
  setUserDataLocalStorage(data, json.data.token);

  context[1]({
    type: "SET_USER",
    payload: {
      data,
    },
  });
};
